/* TENDRA depth: soft light that drifts at different speeds as you scroll, and sections that surface into focus. */
(function () {
  if (window.__tgDepth) return; window.__tgDepth = 1;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var wrap = document.createElement('div');
  wrap.className = 'tg-depth'; wrap.setAttribute('aria-hidden', 'true');
  wrap.innerHTML = '<i class="tg-depth__rays"></i><i class="tg-depth__a"></i><i class="tg-depth__b"></i><i class="tg-depth__c"></i>';
  document.body.appendChild(wrap);
  var layers = [
    { el: wrap.querySelector('.tg-depth__a'), amp: 70, per: 1400, sp: .00011 },
    { el: wrap.querySelector('.tg-depth__b'), amp: 120, per: 900, sp: .00008 },
    { el: wrap.querySelector('.tg-depth__c'), amp: 170, per: 650, sp: .00014 }
  ];

  // sections rise out of soft focus as they come into view
  var main = document.querySelector('main') || document.body;
  var secs = Array.prototype.filter.call(main.querySelectorAll(':scope > .shopify-section, :scope > section'), function (s, i) {
    if (i === 0) return false;
    if (s.querySelector('form[action*="/cart/add"], product-form, .product-info')) return false;
    return true;
  });
  if (!reduce && 'IntersectionObserver' in window) {
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-up'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    secs.forEach(function (s) {
      if (s.getBoundingClientRect().top < vh * 0.9) return; // already on screen: leave it be
      s.classList.add('tg-surface'); io.observe(s);
    });
  }

  if (reduce) return;
  var y = window.scrollY, t0 = performance.now();
  window.addEventListener('scroll', function () { y = window.scrollY; }, { passive: true });
  var loop = function (t) {
    var tt = t - t0;
    for (var i = 0; i < layers.length; i++) {
      var L = layers[i];
      var dy = Math.sin(y / L.per) * L.amp;
      var dx = Math.sin(tt * L.sp + i * 2) * 40;
      L.el.style.transform = 'translate3d(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px,0)';
    }
    if (!document.hidden) requestAnimationFrame(loop);
  };
  document.addEventListener('visibilitychange', function () { if (!document.hidden) requestAnimationFrame(loop); });
  requestAnimationFrame(loop);
})();
